import {useApp} from "@/js/app.js";
import ErrorView from '@/js/Views/Error.vue';

const setup = window.setup;
useApp(ErrorView, setup)
    .mount('#app');